import { render, staticRenderFns } from "./ContactsWidget.vue?vue&type=template&id=0a38c556"
import script from "./ContactsWidget.vue?vue&type=script&lang=js"
export * from "./ContactsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports